@use "../../styles/colors";

:global {
  body[class*="theme-"].theme {
    :local {
      .editable {
        width: 100%;
        font-size: 0.875rem;
        font-weight: 400;
        line-height: 1.375rem;
        resize: none;
        color: colors.$mmc-black;

        &:has([data-slate-placeholder="true"]) {
          height: 1.375rem;
        }
      }
    }
  }
}
